import React from "react";

import { useConnections } from "@/shared/api/apps";

import type { SetupProps } from "../types";

/* An agent acts through the apps linked to it, and a new interface answers
   anyone who can message it (00-PLAN.md → Risks: "strangers using the owner's
   accounts"). Said before connecting, while it can still change a mind. */
export function LinkedAppsWarning({ agent }: Pick<SetupProps, "agent">) {
  const { data } = useConnections(agent.id);
  const apps = [...new Set((data ?? []).filter((c) => c.link?.enabled !== false).map((c) => c.app.name))];
  if (!apps.length) return null;
  return (
    <p className="m-0 rounded-[10px] bg-[var(--warn-bg)] text-[var(--warn-text)] ring-1 ring-[var(--warn-ring)] px-3 py-2 text-[12.5px] leading-[1.5]">
      Anyone who can message it can have {agent.name} use its linked apps — {apps.join(", ")}. Limit who can
      talk to it in Configure once it is connected.
    </p>
  );
}
